import * as React from 'react';
import { connect } from 'react-redux';
import Media from 'react-media';

import styled, { withTheme, keyframes } from 'styled-components';
import Link from 'gatsby-link';
import { Transition } from 'react-transition-group';

import * as navigation from '../../state/ducks/navigation';

import * as styleHelpers from '../../helpers/styleHelpers';

import { Wrapper } from '../primitives/layout';
import { H1 } from '../primitives/typography';
import Hamburger from '../primitives/Hamburger';
import StyledLink from '../primitives/StyledLink';
import { TRANSITION_STATES } from '../primitives/transition';

const InnerWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  z-index: 3;
`;

const NavWrapper = styled.ul`
  display: block;
  margin: 0;
  display: flex;
`;
const NavItem = styled.li`
  display: inline-block;
  padding-left: 2rem;
  font-size: 1.5rem;
  align-items: center;
  display: flex;
  margin: 0;
  list-style-type: none;
`;

const TitleLink = styled(Link)`
  display: block;
`;

class DesktopNav extends React.Component {
  render() {
    return (
      <NavWrapper>
        <NavItem>
          <StyledLink activeClassName="active" to="gallery">
            Portfolio
          </StyledLink>
        </NavItem>
        <NavItem>
          <StyledLink activeClassName="active" to="about">
            About
          </StyledLink>
        </NavItem>
      </NavWrapper>
    );
  }
}

const op1 = `{ opacity: 1; }`;
const op0 = `{ opacity: 0; }`;
const animateIn = keyframes`
  from ${op0}
  to ${op1}
`;
const animateOut = keyframes`
  from ${op1}
  to ${op0}
`;

class MobileMenu extends React.Component {
  static Wrapper = styled.nav`
    position: absolute;
    left: 0;
    padding: ${props => styleHelpers.renderUnitSize(props.theme, 2)};
    width: 100%;
    z-index: 5;
    opacity: ${props => (props.active ? 1 : 0)};
    animation-name: ${props => (props.active ? animateIn : animateOut)};
    animation-duration: ${props => props.theme.transition.standard}ms;
    animation-timing-function: ease-in-out;
    animation-fill-mode: 'forwards';
  `;
  static Ul = styled.ul`
    margin: 0;
  `;
  static Li = styled.li`
    margin: 0;
    list-style-type: none;
    padding-bottom: ${props => styleHelpers.renderUnitSize(props.theme, 1)};
    text-align: center;
    font-size: 1.5rem;
    line-height: 2rem;
  `;

  render() {
    return (
      <MobileMenu.Wrapper active={this.props.active}>
        <MobileMenu.Ul>
          <MobileMenu.Li>
            <StyledLink activeClassName="active" to="gallery">
              Portfolio
            </StyledLink>
          </MobileMenu.Li>
          <MobileMenu.Li>
            <StyledLink activeClassName="active" to="about">
              About
            </StyledLink>
          </MobileMenu.Li>
        </MobileMenu.Ul>
      </MobileMenu.Wrapper>
    );
  }
}

class SiteHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mounted: false };
  }

  componentDidMount() {
    this.setState({ mounted: true });
  }

  render() {
    const { theme, navActive } = this.props;
    return (
      <Wrapper size={[0, 0, 2, 0]} sizes={{ lrg: [0, 0, 3, 0] }}>
        <InnerWrapper>
          <H1>
            <TitleLink to="">TOM ALLEN</TitleLink>
          </H1>
          <Media query={styleHelpers.minBreakPointRaw(theme.breakPoints.lrg)}>
            {isLrg =>
              isLrg && this.state.mounted ? (
                <DesktopNav />
              ) : (
                <Hamburger
                  onToggle={this.props.toggle}
                  outerSize={3}
                  innerSize={2}
                  active={navActive}
                />
              )
            }
          </Media>
        </InnerWrapper>
        <Media query={styleHelpers.minBreakPointRaw(theme.breakPoints.lrg)}>
          {isLrg =>
            !isLrg && (
              <Transition
                in={navActive}
                timeout={theme.transition.standard + 10}>
                {state =>
                  state !== TRANSITION_STATES.EXITED && (
                    <MobileMenu
                      active={[
                        TRANSITION_STATES.ENTERING,
                        TRANSITION_STATES.ENTERED,
                      ].includes(state)}
                    />
                  )
                }
              </Transition>
            )
          }
        </Media>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  navActive: navigation.selectors.isActive(state),
});

export default connect(mapStateToProps, navigation.actionCreators)(
  withTheme(SiteHeader),
);



// WEBPACK FOOTER //
// ./src/components/modules/SiteHeader.js